import React, { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import EditHeader from "components/PantallasEdit/Header/EditHeader";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import EditContainer from "components/PantallasEdit/EditContainer/EditContainer";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import useQueryParams from "hooks/useQueryParams";
import { ItemManager } from "managers";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import useMessage from "hooks/useMessage";
import useExceptionHandler from "hooks/useExceptionHandler";
import Select from "react-select";

export default function ItemEdit({ showLoading, hideLoading }) {
  const [item, setItem] = useState({});
  const [tituloHeader, setTituloHeader] = useState("Crear Item");

  const URLParameters = useQueryParams();
  const IdSec = URLParameters.get("IdSec");
  const esNuevo = !IdSec;
  const { Message, cerrarAlertas } = useMessage();
  const { handleException } = useExceptionHandler();

  const INDICADOR_FACTURACION_LIST = [
    { value: 0, label: "No Facturable" },
    { value: 1, label: "ITBIS 18%" },
    { value: 2, label: "ITBIS 16%" },
    { value: 3, label: "ITBIS 0%" },
    { value: 4, label: "Exento" },
    { value: 5, label: "ITBIS 18% del 10 %" },
  ];

  const INDICADOR_BIEN_O_SERVICIO_LIST = [
    { value: 0, label: "Bien" },
    { value: 1, label: "Servicio" },
  ];

  const ESTATUS_LIST = [
    { value: true, label: "Activo" },
    { value: false, label: "Inactivo" },
  ];

  useEffect(() => {
    if (IdSec) {
      showLoading();
      cargarItem(IdSec);
      setTituloHeader("Editar Item");
    } else {
      setDefaultValues();
      setTituloHeader("Crear Item");
    }
    hideLoading();
    cerrarAlertas();
    return () => { };
  }, [IdSec]);

  const setDefaultValues = () => {
    setItem({
      Nombre: "",
      Descripcion: "",
      IndicadorFacturacion: "",
      IndicadorBienOServicio: "",
      PrecioUnitario: "",
      Estatus: true,
    });
  };

  const cargarItem = (IdSec) => {
    showLoading();
    ItemManager.buscarPorId(IdSec).then((data) => {
      if (data && data.IdSec) {
        setItem({
          ...data,
          Estatus: data.Estatus === 'A',
        });
      } else {
        Message({ message: "Item no encontrado", type: "error" });
      }
    })
      .catch((e) => handleException(e))
      .finally(() => hideLoading());
  };

  function grabar() {
    showLoading();

    const payload = {
      ...item,
      Estatus: item.Estatus ? 'A' : 'I'
    };

    if (esNuevo) {
      ItemManager.crear(payload)
        .then((_res) => {
          Message({ message: `Grabado Exitosamente` });
        })
        .catch((e) => handleException(e))
        .finally(() => hideLoading());
    } else {
      ItemManager.actualizar(payload)
        .then((res) => {
          Message({ message: `Actualizado Exitosamente` });
          cargarItem(payload.IdSec);
        })
        .catch((e) => handleException(e))
        .finally(() => hideLoading());
    }
  }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setItem({
      ...item,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  return (
    <>
      <Form action="" className="form-horizontal" method="">
        <Card>
          <EditHeader
            titulo={tituloHeader}
            volver={true}
            grabar={grabar}
          />
          <EditContainer>
            <EditSection title="Información General">
              <SectionRow>
                <InputContainer label="Nombre">
                  <Form.Control
                    type="text"
                    name="Nombre"
                    value={item.Nombre}
                    onChange={handleChange}
                  />
                </InputContainer>
              </SectionRow>
              <SectionRow>
                <InputContainer label="Descripción">
                  <Form.Control
                    type="text"
                    name="Descripcion"
                    value={item.Descripcion}
                    onChange={handleChange}
                  />
                </InputContainer>
              </SectionRow>
              <SectionRow>
                <InputContainer label="Indicador Facturación">
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    name="IndicadorFacturacion"
                    options={INDICADOR_FACTURACION_LIST}
                    value={INDICADOR_FACTURACION_LIST.filter(
                      (option) => option.value === item.IndicadorFacturacion
                    )}
                    onChange={(selectedOption) => {
                      setItem({
                        ...item,
                        IndicadorFacturacion: selectedOption
                          ? selectedOption.value
                          : null,
                      });
                    }}
                  />
                </InputContainer>
              </SectionRow>
              <SectionRow>
                <InputContainer label="Indicador Bien o Servicio">
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    name="IndicadorBienOServicio"
                    options={INDICADOR_BIEN_O_SERVICIO_LIST}
                    value={INDICADOR_BIEN_O_SERVICIO_LIST.filter(
                      (option) => option.value === item.IndicadorBienOServicio
                    )}
                    onChange={(selectedOption) => {
                      setItem({
                        ...item,
                        IndicadorBienOServicio: selectedOption
                          ? selectedOption.value
                          : null,
                      });
                    }}
                  />
                </InputContainer>
              </SectionRow>
              <SectionRow>
                <InputContainer label="Precio Unitario">
                  <Form.Control
                    type="number"
                    name="PrecioUnitario"
                    value={item.PrecioUnitario}
                    onChange={handleChange}
                  />
                </InputContainer>
              </SectionRow>
                <SectionRow>
                  <InputContainer label="Estatus">
                    <Select
                      className="react-select primary"
                      classNamePrefix="react-select"
                      name="Estatus"
                      options={ESTATUS_LIST}
                      value={ESTATUS_LIST.find(
                        (option) => option.value === item.Estatus
                      )}
                      onChange={(selectedOption) => {
                        setItem({
                          ...item,
                          Estatus: selectedOption.value,
                        });
                      }}
                      isDisabled={esNuevo}
                    />
                  </InputContainer>
                </SectionRow>
            </EditSection>
          </EditContainer>
        </Card>
      </Form>
    </>
  );
}